export const formStepInputStyles = {
  fontSize: 16,
  width: '100%',
  height: 48,
  lineHeight: '28px',
};
